import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { shallow } from '@jwp/ott-common/src/utils/compare';

import { modalURLFromLocation } from '../../utils/location';
import Button from '../Button/Button';
import CancelIcon from '../../../../theme/assets/icons/cancel_confirm.svg';
import { useTheme } from '../../../../../ThemeContext';

import styles from './WarningHasSubscription.module.scss';

const WarningHasSubscription = ({ isActiveSubscription }: { isActiveSubscription: boolean }) => {
  const { t } = useTranslation('account');
  const navigate = useNavigate();
  const location = useLocation();
  const { universalStyles } = useTheme();

  const { customer, subscription, allSubscriptions } = useAccountStore(
    ({ user, subscription, allSubscriptions }) => ({
      customer: user,
      subscription,
      allSubscriptions,
    }),
    shallow,
  );

  const registerSource = customer?.metadata?.register_source;
  const isSocialLogin = (registerSource && registerSource !== 'inplayer') || false;
  const shouldAddPassword = (isSocialLogin && !customer?.metadata?.has_password) || false;

  // Calculate expiresAt
  const currentTimestamp = Math.floor(Date.now() / 1000);
  //   const oneDayInSeconds = 24 * 60 * 60;

  const validCancelledSubscriptions =
    allSubscriptions?.filter((subscription) => {
      const newExpiredTimestamp = subscription?.expiresAt;
      //   const newExpiredTimestamp = rawSubscriptionTimestamp - oneDayInSeconds;
      return subscription.status === 'cancelled' && newExpiredTimestamp !== undefined && newExpiredTimestamp >= currentTimestamp;
    }) ?? [];

  const highestExpiresAt = validCancelledSubscriptions.length > 0
    ? Math.max(...validCancelledSubscriptions.map((sub) => sub.expiresAt))
    : undefined;

  let expiresAtObject: Date | undefined = undefined;
  if (highestExpiresAt !== undefined) {
    expiresAtObject = new Date((highestExpiresAt) * 1000);
  }
  const expiresAt = expiresAtObject
    ? expiresAtObject.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).replace(',', '')
    : '';

  const closeHandler = () => {
    navigate(modalURLFromLocation(location, null), { replace: true });
  };

  const SubmitHandler = () => {
    if (!isActiveSubscription) {
      navigate(modalURLFromLocation(location, shouldAddPassword ? 'warning-account-deletion' : 'delete-account'));
    } else {
      navigate('u/payments');
    }
  };

  if (isActiveSubscription) {
    return (
      <div>
        <center>
          <span className={styles.icon}>
            <img src={CancelIcon} />
          </span>
        </center>
        <h2 className={styles.heading} style={universalStyles.primaryTextColor}>
          {t('user:payment.cancel_subscription')}
        </h2>
        <p className={styles.paragraph} style={universalStyles.primaryTextColor}>
          {t('cancel_subscription.cancel_subscription_Warning_content')}
        </p>
        <div className={styles.buttonBar}>
          <span>
            <Button
              onClick={SubmitHandler}
              size="exlarge"
              variant="signoutYes"
              label={t('cancel_subscription.go_to_subscription')}
              className={styles.confirmButton}
            />
          </span>
          <span>
            <Button
              onClick={closeHandler}
              color="primary"
              size="exlarge"
              variant="signoutNo"
              label={t('Cancel')}
              className={styles.confirmButton}
            />
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <center>
          <span className={styles.icon}>
            <img src={CancelIcon} />
          </span>
        </center>
        <h2 className={styles.heading} style={universalStyles.primaryTextColor}>
          {t('user:payment.cancel_subscription')}
        </h2>
        <p className={styles.paragraph} style={universalStyles.primaryTextColor}>
          {t('cancel_subscription.cancelled_active_subscription_Warning_content', {
            date: expiresAt,
          })}
        </p>
        <div className={styles.buttonBar}>
          <span>
            <Button
              onClick={SubmitHandler}
              size="exlarge"
              variant="signoutYes"
              label={t('cancel_subscription.go_to_delete_account')}
              className={styles.confirmButton}
            />
          </span>
          <span>
            <Button
              onClick={closeHandler}
              color="primary"
              size="exlarge"
              variant="signoutNo"
              label={t('Cancel')}
              className={styles.confirmButton}
            />
          </span>
        </div>
      </div>
    );
  }
};

export default WarningHasSubscription;
